/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SettingEntity,
} from '../models/index';
import {
    SettingEntityFromJSON,
    SettingEntityToJSON,
} from '../models/index';

/**
 * 
 */
export class SettingApi extends runtime.BaseAPI {

    /**
     * 設定を1件登録する。
     */
    async createSettingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SettingEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettingEntityFromJSON(jsonValue));
    }

    /**
     * 設定を1件登録する。
     */
    async createSetting(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SettingEntity> {
        const response = await this.createSettingRaw(initOverrides);
        return await response.value();
    }

    /**
     * テナントに紐づく設定一覧を取得する。
     */
    async listSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SettingEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SettingEntityFromJSON));
    }

    /**
     * テナントに紐づく設定一覧を取得する。
     */
    async listSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SettingEntity>> {
        const response = await this.listSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 設定を1件更新する。
     */
    async updateSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SettingEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettingEntityFromJSON(jsonValue));
    }

    /**
     * 設定を1件更新する。
     */
    async updateSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SettingEntity> {
        const response = await this.updateSettingsRaw(initOverrides);
        return await response.value();
    }

}
